import querystring from "query-string";

import { mergeAuthSearchParams } from "../../routes/auth-routes";
import type { RegisterSource, RegistrationTrackingParameters } from "../../types";
import { isServerSide } from "../isServerSide";

export const REGISTRATION_TYPE = "registration_type";
export const REGISTRATION_OFFLINE = "offline";
export const OFFLINE_HASH = "hash";

const getLocationSearch = (): string => {
  if (isServerSide()) {
    return "";
  }

  return mergeAuthSearchParams(window.location.search, window.location.hash ?? "").toString();
};

export const isOfflineRegistrationVariant = (): boolean => {
  const { registration_type } = querystring.parse(getLocationSearch());

  return registration_type === REGISTRATION_OFFLINE;
};

export const isVerifiedOfflineAvVariant = (): boolean => {
  const { hash } = querystring.parse(getLocationSearch());

  return Boolean(hash && isOfflineRegistrationVariant());
};

export const isNonVerifiedOfflineAvVariant = (): boolean =>
  isOfflineRegistrationVariant() && !isVerifiedOfflineAvVariant();

export const getIsOfflineRegistrationAvForced = (): boolean => {
  const { force_av } = querystring.parse(getLocationSearch());
  const isOfflineRegistration = isOfflineRegistrationVariant();
  return force_av === "true" && isOfflineRegistration;
};

export const getIsRedirectToDashboardAfterRegistration = (): boolean => {
  const { should_redirect_to_dashboard } = querystring.parse(getLocationSearch());
  const isOfflineRegistration = isOfflineRegistrationVariant();
  return should_redirect_to_dashboard === "true" && isOfflineRegistration;
};

export const getOfflineSourceRegisterData = (): RegisterSource | undefined => {
  const { hash, representative_id, source_id, source_type, timestamp, registration_type } = querystring.parse(
    getLocationSearch(),
    {}
  );
  if (registration_type === REGISTRATION_OFFLINE) {
    return {
      hash: hash?.toString(),
      representative_id: representative_id?.toString() || "",
      source_id: source_id?.toString() || "",
      source_type: source_type?.toString() || "",
      timestamp: timestamp?.toString(),
      channel: REGISTRATION_OFFLINE,
    };
  }
  return undefined;
};

export const getOfflineTrackingRegisterData = (): RegistrationTrackingParameters | undefined => {
  const { registration_type, channel_id, channel_type, country, campaign_id, content_id, guided_trial, program_id } =
    querystring.parse(getLocationSearch(), {});

  const isTrackingParamExist =
    channel_id || channel_type || country || campaign_id || content_id || guided_trial || program_id;

  if (registration_type === REGISTRATION_OFFLINE && isTrackingParamExist) {
    return {
      channel_id: channel_id?.toString(),
      channel_type: channel_type?.toString(),
      country: country?.toString(),
      campaign_id: campaign_id?.toString(),
      content_id: content_id?.toString(),
      guided_trial: typeof guided_trial === "string" ? guided_trial === "true" : undefined,
      program_id: program_id?.toString(),
    };
  }
  return undefined;
};
